export default __webpack_public_path__ + "_/shared/assets/icons/products/nail.webp";